import httpClient from "./httpClient";

const base = "/attendance/reports";

export function getStudentDailySection(date, periodId, classConfigId) {
  return httpClient.get(`${base}/student/daily-section`, { params: { date, periodId, classConfigId } }).then((res) => res.data.data);
}

export function getStudentMonthlySummary(classConfigId, periodId, monthName, year) {
  return httpClient
    .get(`${base}/student/monthly-summary`, { params: { classConfigId, periodId, monthName, year } })
    .then((res) => res.data.data);
}

export function getSectionWiseDailySummary(date, periodId, activeOnly) {
  return httpClient
    .get(`${base}/student/section-wise-daily-summary`, { params: { date, periodId, activeOnly } })
    .then((res) => res.data.data);
}

export function getStudentMonthlyDetails(classConfigId, periodId, monthName, year) {
  return httpClient
    .get(`${base}/student/monthly-details`, { params: { classConfigId, periodId, monthName, year } })
    .then((res) => res.data.data);
}

export function getStaffDateWise(date) {
  return httpClient.get(`${base}/staff/date-wise`, { params: { date } }).then((res) => res.data.data);
}

export function getStaffTimeConfigurationReport() {
  return httpClient.get(`${base}/staff/time-configuration-report`).then((res) => res.data.data);
}

export function getStaffMonthlyDetails(teacherSectionIds, shiftIds, monthName, year, showTimes) {
  const params = new URLSearchParams();
  teacherSectionIds.forEach((id) => params.append("teacherSectionIds", id));
  shiftIds.forEach((id) => params.append("shiftIds", id));
  params.append("monthName", monthName);
  params.append("year", year);
  params.append("showTimes", showTimes);
  return httpClient.get(`${base}/staff/monthly-details?${params.toString()}`).then((res) => res.data.data);
}
